/* eslint-disable */

import request from 'assets/js/http';

export function queryFundList(data) {
  // 查询基金列表
  return request({
    url: '/finance/queryFundList',
    method: 'post',
    data: data
  });
}

export function queryFairCommon(data) {
  // 查询公允价值表common
  return request({
    url: '/finance/queryFairCommon',
    method: 'post',
    data: data
  });
}

export function queryVersionDetail(data) {
  return request({
    url: '/finance/queryVersionDetail',
    method: 'post',
    data: data
  });
}

export function queryFairDetail(data) {
  console.log('获取表格详情接口', data);
  return request({
    url: '/finance/queryFairDetail',
    method: 'post',
    data: data
  });
}

export function modifyDetail(data) {
  console.log('修改表格', data);
  return request({
    url: '/finance/modifyDetail',
    method: 'post',
    data: data
  });
}

export function nameLogVersion(data) {
  console.log('api:nameversion', data);
  return request({
    url: '/finance/nameAndLog',
    method: 'post',
    data: data
  });
}

export function queryLastDate(data) {
  return request({
    url: '/finance/queryLastDate',
    method: 'post',
    data: data
  });
}

export function newFair(data) {
  console.log('api:newFair', data);
  return request({
    url: '/finance/newFair',
    method: 'post',
    data: data,
    timeout: 50000
  });
}

export function fixVersion(data) {
  console.log(data, 'fixVersion');
  return request({
    url: '/finance/fixVersion',
    method: 'post',
    data: data
  });
}

export function newVersion(data) {
  console.log('api:newVersion', data);
  return request({
    url: '/finance/newVersion',
    method: 'post',
    data: data
  });
}

export function queryChange(data) {
  console.log(data, '查询变更记录');
  return request({
    url: '/finance/queryChange',
    method: 'post',
    data: data,
    timeout: 50000
  });
}

export function publish(data) {
  console.log('api:publish', data);
  return request({
    url: '/finance/release',
    method: 'post',
    data: data
  });
}

export function saveByRefresh(data) {
  console.log('saveByRefresh', data);
  return request({
    url: '/finance/saveByRefresh',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data,
    timeout: 50000
  });
}
/**
 * 查询变更记录
 * @param {type} 新建or刷新
 * @param {entityId} 基金id
 * @param {endDate} 本次截止日期时间戳
 */
//checked
export function compareVersion(data) {
  console.log('版本对比', data);
  return request({
    url: '/finance/compareVersion',
    method: 'post',
    data: data
  });
}

export function deleteFair(data) {
  console.log('deleteFair', data);
  return request({
    url: '/finance/deleteFair',
    method: 'post',
    data: data
  });
}

export function newForecast(data) {
  console.log('newForecast', data);
  return request({
    url: '/finance/newForecast',
    method: 'post',
    data: data
  });
}

export function renameFair(data) {
  return request({
    url: '/finance/rename',
    method: 'post',
    data: data
  });
}

export function switchVersion(data) {
  return request({
    url: '/finance/switchVersion',
    method: 'post',
    data: data
  });
}

/**   分界线  分界线  分界线  -------------------------------- 分界线 分界线 分界线  */

/**   分界线  分界线  分界线  -------------------------------- 分界线 分界线 分界线  */

export function getOptionLists(data) {
  return Promise.resolve({
    msg: '',
    code: 200,
    data: {
      fundList: [
        {
          id: 1,
          name: '苏州源瀚'
        }
      ],
      tableList: [
        {
          id: 1,
          name: '2019年Q3汇总表'
        }
      ],
      fieldList: [
        {
          id: 1,
          name: '企业服务'
        }
      ],
      realizedList: [
        {
          id: 1,
          name: '未实现部分'
        }
      ],
      sumList: [
        {
          id: 1,
          name: '>=1亿'
        }
      ],
      ownershipRatioList: [{ id: 1, name: '>=20%' }],
      roundList: [{ id: 1, name: '天使轮' }]
    }
  });
}

//中间页项目列表
export function projectListQuery(data) {
  return request({
    url: '/finance/projectListQuery',
    method: 'post',
    data: data
  });
}

//中间页人员列表
export function projectListCommon(data) {
  return request({
    url: '/finance/projectListCommon',
    method: 'post',
    data: data
  });
}

//获取项目中间页详情
export function projectDetailQuery(data) {
  return request({
    url: '/finance/projectDetailQuery',
    method: 'post',
    data: data
  });
}

//修改估值标准
export function latestManage(data) {
  return request({
    url: '/finance/latestManage',
    method: 'post',
    data: data
  });
}

//基金列表
export function fundListCommon(data) {
  return request({
    url: '/finance/fundListCommon',
    method: 'post',
    data: data
  });
}

//已投基金列表
export function fundListForExitCommon(data) {
  return request({
    url: '/finance/fundListForExitCommon',
    method: 'post',
    data: data
  });
}

//项目状态变更
export function projectManage(data) {
  return request({
    url: '/finance/projectManage',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

//获取财务人员列表
export function getFinanceUsers(data) {
  return request({
    url: '/finance/getFinanceUsers',
    method: 'post',
    data: data
  });
}

//设置项目权限
export function setProjectAuth(data) {
  return request({
    url: '/finance/setProjectAuth',
    method: 'post',
    data: data
  });
}

//查询基金列表-权限
export function queryFundListForAuth(data) {
  return request({
    url: '/finance/queryFundListForAuth',
    method: 'post',
    data: data
  });
}

//设置基金权限
export function setFundAuth(data) {
  return request({
    url: '/finance/setFundAuth',
    method: 'post',
    data: data
  });
}

//设置基金财务人员
export function fundListForAuthCommon(data) {
  return request({
    url: '/finance/fundListForAuthCommon',
    method: 'post',
    data: data
  });
}

//投资
export function dealEvent(data) {
  return request({
    url: '/finance/dealEvent',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

//投资
export function dealInvest(data) {
  return request({
    url: '/finance/dealInvest',
    method: 'post',
    data: data
  });
}

//转股
export function dealConversion(data) {
  return request({
    url: '/finance/dealConversion',
    method: 'post',
    data: data
  });
}

//退出
export function dealExit(data) {
  return request({
    url: '/finance/dealExit',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

// 项目审核时间更新list
export function companyAuditUpdateList(data) {
  return request({
    url: '/finance/companyAuditUpdateList',
    method: 'post',
    data: data
  });
}

//获取项目中间页切片
export function projectDetailSliceQuery(data) {
  return request({
    url: '/finance/projectDetailSliceQuery',
    method: 'post',
    data: data
  });
}

//估值切片管理
export function sliceLatestManage(data) {
  return request({
    url: '/finance/sliceLatestManage',
    method: 'post',
    data: data
  });
}

//投资切片管理
export function sliceDealInvest(data) {
  return request({
    url: '/finance/sliceDealInvest',
    method: 'post',
    data: data
  });
}

//退出切片管理
export function sliceDealExit(data) {
  return request({
    url: '/finance/sliceDealExit',
    method: 'post',
    data: data
  });
}

//查询汇率（增）
export function queryRate(data) {
  return request({
    url: '/finance/queryRate',
    method: 'post',
    data: data
  });
}

//项目概况-编辑
export function dealSummary(data) {
  return request({
    url: '/financeCompany/deal',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

// 基金基本信息查询
export function queryFinanceFundList(data) {
  return request({
    url: '/financeFund/queryList',
    method: 'post',
    data: data
  });
}

// 基金基本信息编辑
export function dealFinanceFund(data) {
  return request({
    url: '/financeFund/deal',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

// 公允价值表基金总览信息编辑
export function modifyFinanceFairOverview(data) {
  return request({
    url: '/financeFair/modifyOverview',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: data
  });
}

// 公允价值表基金总览信息编辑
export function queryVersionType(data) {
  return request({
    url: '/financeVersion/queryVersionType',
    method: 'post',
    data: data
  });
}
